<template>
  <router-view/>
</template>

<style lang="scss">
body{
    padding: 0;margin: 0 !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.dm-form-item{width: 98%;padding: 10px 10px 0 10px;background-color: #f2f2f2;border-radius: 6px;
    margin-top: 8px;color: #8f8d8d;
    overflow: hidden;
}
.dm-money{font-weight: bold;font-size: 16px; color: darkorange;}
</style>
